import React from 'react';
import { Helmet } from 'react-helmet';
import Gallery from './Gallery/Gallery';
import Header from './Header/Header';
import JoinMe from './JoinMe/JoinMe';
import Services from './Services/Services';
import ContactMe from '../ContactMe/ContactMe';
import JoinClass from './JoinClass/JoinClass';

const Home = () => {
    return (
        <div className='container'>
            <Helmet>
                <title>Home - Fit With Me</title>
            </Helmet>
            <Header></Header>
            <Services></Services>
            <JoinClass />
            <JoinMe></JoinMe>
            <Gallery></Gallery>
            <ContactMe />
        </div>
    );
};

export default Home;